import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import Layout from '../components/Layout';

const TransportManagementSystem = () => {
  const [activeTab, setActiveTab] = useState('ss');

  return (
    <Layout>
      <section id="greenorange-dest">
        <section className="banner">
          <div className="container">
            <div className="row">
              <div className="col-lg-12 col-md-12 col-sm-12">
                <h1 className="mar0">Transport Management System - TMS</h1>
                <p className="colorWht">Solve complex transportation challenges across any mode.</p>
              </div>
            </div>
          </div>
        </section>
        <section className="content-dest">
          <div className="col-lg-12 content-dest-bg">
            <div className="col-lg-5 col-md-5 col-sm-6 padTB58 text-right">
              <img src="/images/transport_management_system.jpg" alt="transport_management_system" className="content-img" />
            </div>
            <div className="col-lg-3 col-md-3 col-sm-6 padTB58 padLR15">
              <p>
                Whether you operate your own private fleet or procure outside carrier services, our Transportation Management software offers the scope of solutions you need to run a comprehensive, integrated system-and achieve better results than you ever thought possible. Fully cloud-enabled, the solution set is available in multiple deployment options, including multi-tenant, private hosted, on-premise or hybrid options.
              </p>
            </div>
            <div className="col-lg-4 col-md-4 col-sm-12 bgwhite">
              <div className="dest-rightside">
                <div>You may also be interested in <span> our other products</span></div>
                <ul className="pad0">
                  <li><Link to="/payroll" title="Payroll Management System">Payroll Management System</Link></li>
                  <li><Link to="/gps-tracking-software" title="GPS Tracking as Software">GPS Tracking as Software</Link></li>
                </ul>
              </div>
            </div>
          </div>
        </section>
        <div className="clearfix"></div>
        <section className="content-dest1">
          <div className="container">
            <div className="row">
              <div className="col-lg-12 col-md-12 col-sm-12">
                <h2>Why Green Orange's Transport Management System?</h2>
                <ul className="">
                  <li>Get a "what-if" analysis with transportation modeling to determine the impact of altering your transportation policies before you execute.</li>
                  <li>Reduce time for RFP preparation and better communication with bidders.</li>
                  <li>Minimize costs by maximizing utilization of all transportation assets.</li>
                  <li>Simplify billing and reduce freight payment errors.</li>
                  <li>Turn more loads in less time with no delays or charge-backs.</li>
                  <li>Ability for companies to self-host or have GreenOrange host the transportation management system (TMS), and integrates with most legacy, Enterprise Resource Planning (ERP) applications.</li>
                  <li>Offers a secure logistics and supply chain management computing environment.</li>
                </ul>
              </div>
            </div>
          </div>
        </section>
        <section className="content-tab">
          <div className="container">
            <div className="row">
              <div className="col-lg-12 col-md-12 col-sm-12">
                <div id="tab-dest">
                  <ul className="nav nav-tabs" role="tablist">
                    <li role="presentation" className={activeTab === 'ss' ? 'active' : ''}>
                      <a
                        href="#ss"
                        title="Solutions & Support"
                        role="tab"
                        onClick={(e) => {
                          e.preventDefault();
                          setActiveTab('ss');
                        }}
                      >
                        Solutions & Support
                      </a>
                    </li>
                    <li role="presentation" className={activeTab === 'EPD' ? 'active' : ''}>
                      <a
                        href="#EPD"
                        title="Electronic Proof of Delivery"
                        role="tab"
                        onClick={(e) => {
                          e.preventDefault();
                          setActiveTab('EPD');
                        }}
                      >
                        Electronic Proof of Delivery
                      </a>
                    </li>
                    <li role="presentation" className={activeTab === 'tmsInv' ? 'active' : ''}>
                      <a
                        href="#tmsInv"
                        title="TMS Invoicing"
                        role="tab"
                        onClick={(e) => {
                          e.preventDefault();
                          setActiveTab('tmsInv');
                        }}
                      >
                        TMS Invoicing
                      </a>
                    </li>
                    <li role="presentation" className={activeTab === 'tmsFA' ? 'active' : ''}>
                      <a
                        href="#tmsFA"
                        title="TMS Financial Accounting"
                        role="tab"
                        onClick={(e) => {
                          e.preventDefault();
                          setActiveTab('tmsFA');
                        }}
                      >
                        TMS Financial Accounting
                      </a>
                    </li>
                  </ul>
                  <div className="tab-content">
                    <div
                      role="tabpanel"
                      className={`tab-pane fade ${activeTab === 'ss' ? 'in active' : ''}`}
                      id="ss"
                    >
                      <ul className="tab-pane-dest pad0">
                        <li>Manage carriers and transportation contracts</li>
                        <li>Configure route guides and quote/rate shipments</li>
                        <li>Plan and optimize shipments</li>
                        <li>Track shipments to improve visibility and manage performance</li>
                        <li>Support supplier and carrier compliance programs</li>
                      </ul>
                    </div>
                    <div
                      role="tabpanel"
                      className={`tab-pane fade ${activeTab === 'EPD' ? 'in active' : ''}`}
                      id="EPD"
                    >
                      <p>
                        Instead of requiring your drivers to maintain and submit physical paperwork every day – mobile, electronic proof of delivery (ePoD) solutions enable you to provide tracking in real-time and replace manual, paper-based solutions.
                      </p>
                      <p>
                        Paper-based, manual processes are a common source of problems that can degrade the customer experience. In addition, they prevent real-time data access, which is vital to rapid and effective problem resolution. This lack of visibility causes dissatisfaction and can erode your reputation as a supplier or distributor.
                      </p>
                      <p>If you can't reliably fulfill orders, your customers may quickly find a competitor who can.</p>
                      <p>It can be challenging to manage a complex system based upon manual, paper proof of delivery. By providing electronic proof of delivery you will:</p>
                      <ul className="tab-pane-dest pad0">
                        <li>Provide your employees with easy-to-use technology that streamlines workflows</li>
                        <li>Give your team greater visibility into delivery operations through dashboard access</li>
                        <li>Enable fast access to your customer's delivery, billing, and payment data for greater responsiveness and more accurate recordkeeping</li>
                        <li>Provide integrated delivery alerting features to prevent service incidents</li>
                        <li>Let your customers serve themselves by tracking orders in real time</li>
                      </ul>
                    </div>
                    <div
                      role="tabpanel"
                      className={`tab-pane fade tmsInvoice ${activeTab === 'tmsInv' ? 'in active' : ''}`}
                      id="tmsInv"
                    >
                      <h3 className="marT0">Be professional</h3>
                      <p>Communicate billing effectively and get paid on time</p>
                      <p>
                        Every moment you delay when billing customers costs money, literally. We make it easy to communicate the proper billing information to your customer, at the right time. Whether it's a past due invoice or a failed payment attempt, we help you stay on top of who owes you money.
                        With TMS you can be confident that your invoices uphold your brand's highest standards. No more invoicing with Word or Excel templates.
                      </p>
                      <h3>Earn more, faster</h3>
                      <p>Supercharge your revenue stream with recurring billing and automated chasing</p>
                      <p>
                        Recurring billing, aka subscription billing, allows you to bill clients for the same amount on a recurring basis, like monthly or quarterly. Chasing lets you automate sending friendly payment reminders once an invoice becomes past due according to the schedule you set. TMS is your accounts receivable champion.
                      </p>
                      <h3>Save paper</h3>
                      <p>Avoid the post office by invoicing your clients online and accepting electronic payments</p>
                      <p>
                        Invoices are sent online to clients via email. TMS will keep track of correspondence with your client so you never have to remember if or when you sent that invoice. Everyone gets a hosted TMS portal at yourcompany.greenorange.com.my where clients can view and pay invoices online. The billing portal was designed to remove the friction of paying you. It's great for building long-term relationships with clients.
                      </p>
                    </div>
                    <div
                      role="tabpanel"
                      className={`tab-pane fade tmsFA ${activeTab === 'tmsFA' ? 'in active' : ''}`}
                      id="tmsFA"
                    >
                      <h3 className="marT0">Close With Confidence and Report Financials Quickly and Accurately</h3>
                      <p>
                        TMS online accounting seamlessly couples core accounting functions such as general ledger, accounts receivables and accounts payable with strong compliance management. Improve business performance, increase financial close efficiency and reduce back-office costs with standardized processes using a single, integrated solution.
                      </p>
                      <p>
                        TMS Payments is the smart way to meet all of your payment processing needs directly from within TMS. Whether your business accepts payments through online self-checkout or for the settlement of an outstanding invoice, you can accommodate all customer preferences. And, because it seamlessly integrates with TMS, you will have access to payment-related information in real time.
                      </p>
                      <p>TMS Payments is a complete payment management solution that supports the most payment options and helps prevent fraud.</p>
                      <h4>Areas Covered</h4>
                      <ul className="tab-pane-dest pad0">
                        <li>Accounts receivable</li>
                        <li>Accounts payable</li>
                        <li>Credit/Debit Note</li>
                        <li>Cash book</li>
                        <li>Payments/Receipts</li>
                        <li>Banking</li>
                        <li>P & L</li>
                      </ul>
                      <h4>Payroll</h4>
                      <p>
                        An integrated Payroll within your TMS Software will save you enourmous number of hours required to generate payslips for your employees.
                      </p>
                      <p>
                        GPayroll helps you comply with legal and tax requirements and simplifies the process of paying your employees. With GPayroll - you never need to outsource your Payroll to a third party vendor.
                      </p>
                      <p>GPayroll supports both monthly salary and hourly wages structure.</p>
                      <h4>Time & Attendance</h4>
                      <p>
                        Wanna keep track your employees' hours? A comprehensive and integrated time management module enables employees to record their arrival, departure, lunch break in and out and additional break in and out and provides managers with detailed information about attendance records, absenteeism, overtime etc.
                      </p>
                      <p>
                        GreenOrange offers seamless integration with most biometrics devices, making it easy for you to use your existing finger scan / card reader device to capture your attendance data and migrate it into GPayroll.
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      </section>
    </Layout>
  );
};

export default TransportManagementSystem;

